import { useEffect, useState } from "react";
import INTOUCH_API from "../../../../services/Api";
import { getFormInputsValue } from "../../../../utils/helpers";
import { useNavigate } from "react-router-dom";
import useCookie from "../../../../hooks/useCookie";
import useValidateForm from "../../../../hooks/useValidateForm";

export default function useController() {
  const [isSmsSending, setIsSmsSending] = useState(false);
  const [smsVerified, setSmsVerified] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [refreshTimer, setRefreshTimer] = useState(60);
  const [refreshTimerID, setRefreshTimerID] = useState(null);
  const [isCodeValid, setIsCodeValid] = useState(false);
  const [code, setCode] = useState("");

  const { setCookie } = useCookie();
  const navigate = useNavigate();

  const email = localStorage.getItem("recoveryEmail");

  const onCodeHandle = (event) => {
    event.target.value.trim();
    setCode(event.target.value);
    event.target.value.length === 6
      ? setIsCodeValid(false)
      : setIsCodeValid(true);
  };
  const requestCodeAgain = async () => {
    await sendEmail({ email }).then(() => {
      setRefreshTimer(60);
      timerCountDown();
    });
  };
  const onSubmitCodeHandle = async (event) => {
    if (isSmsSending) return;
    event.preventDefault();
    const formData = {
      email,
      ...getFormInputsValue(event.target.elements),
    };
    formData.code = Number(formData.code);
    await sendSms(formData);
  };
  const sendSms = (formData) => {
    setIsSmsSending(true);
    INTOUCH_API.requestManager(
      "code",
      formData,
      (response) => {
        if (response.data) {
          const inTenMinutes = new Date(new Date().getTime() + 10 * 60 * 1000);
          setCookie("pass_update_token", response.data.token, {
            sameSite: "strict",
            expires: inTenMinutes,
            secure: true,
          });
          grantAccess();
        }
      },
      (error) => {
        setSmsVerified(error?.response?.data.message);
      }
    ).finally(() => {
      setIsSmsSending(false);
    });
  };
  const sendEmail = async (formData) => {
    INTOUCH_API.requestManager("email", formData, (error) => {
      setErrorMessage(error?.response?.data.message);
    }).finally();
  };

  const grantAccess = () => {
    navigate("new-pass");
  };

  const timerCountDown = () => {
    const timerID = setInterval(() => {
      setRefreshTimer((prevTimerState) => prevTimerState - 1);
    }, 1000);
    setRefreshTimerID(timerID);
  };

  useEffect(() => {
    timerCountDown();
    return () => {
      clearInterval(refreshTimerID);
    };
  }, []);

  useEffect(() => {
    if (refreshTimer <= 0) {
      clearInterval(refreshTimerID);
    }
  }, [refreshTimer, refreshTimerID]);
  return {
    onSubmitCodeHandle,
    requestCodeAgain,
    refreshTimer,
    isSmsSending,
    smsVerified,
    isCodeValid,
    code,
    email,
    onCodeHandle,
    errorMessage,
  };
}
